import { Apple } from "react-bootstrap-icons";

export default function PortfolioTab() {
	const projects = [
		{
			title: "Tunero",
			image: "/images/tunero_appicon.png",
			webUrl: "https://tunero.findbluapp.com/",
			appUrl: "https://apps.apple.com/us/app/id6736527031",
			desc: "Create music effortlessly using AI tools to transform your ideas into songs. Enjoy features like lyrics writing and lifelike vocals. Begin your musical adventure with Tunero today!",
			category: "UI & UX Design",
		},
		{
			title: "How to Draw AR Drawing",
			image: "/images/draw_appicon.jpg",
			webUrl: "https://howtodrawsketch.com/",
			appUrl: "https://apps.apple.com/us/app/how-to-draw-sketch-paint/id6478631516",
			desc: "Enhance your drawing skills with AI features for sketching photos, creating stickers, and more. Follow step-by-step drawings and share your progress. Start your journey with How to Draw now!",
			category: "UI & UX Design",
		},
		{
			title: "Real Draw Ai Painter",
			image: "/images/realdraw_appicon.jpg",
			webUrl: "",
			appUrl: "https://apps.apple.com/us/app/realtime-drawing-ai-painter/id6502963759",
			desc: "Transform sketches into stunning AI-enhanced artworks with this user-friendly app for all ages. Share your creations easily. Download AI Painter today!",
			category: "UI & UX Design",
		},
		{
			title: "Findblu Bluetooth Device Finder",
			image: "/images/findblu_appicon.jpg",
			webUrl: "https://findbluapp.com/",
			appUrl: "https://apps.apple.com/us/app/findblu-find-my-lost-device/id6475194794",
			desc: "This app quickly locates lost Bluetooth devices like headphones, smartwatches, and phones. Use the Device Radar to view nearby devices and their distance. Track items hands-free with Siri—just give a command to find them faster.",
			category: "UI & UX Design",
		},
		{
			title: "Teknosa File Manager",
			image: "/images/teknosa_project.jpg",
			webUrl: "https://transfer.teknosa.com/",
			desc: "Teknosa File Manager ensures secure file sharing among Teknosa managers with SMS verification, enhancing data security and seamless communication.",
			category: "Frontend Development",
		},
		{
			title: "Manas Dashboard",
			image: "/images/manas_project.jpg",
			webUrl: "https://manas.hepapp.com/",
			desc: "Manas Dashboard provides a user-friendly platform for effective data visualization and analysis, streamlining data management and reporting.",
			category: "Frontend Development",
		},
		{
			title: "Findvice App Landing Page",
			image: "/images/findvice_project.jpg",
			webUrl: "https://findviceapp.com/",
			appUrl: "https://apps.apple.com/us/app/find-my-lost-earbuds-bickster/id1662339120",
			desc: "The Findvice App Landing Page promotes the Findvice mobile app, detailing its features and benefits to inform potential users and support app downloads.",
			category: "Frontend Development",
		},
		{
			title: "Edetay Yapi Landing Page",
			image: "/images/edetayyapi_project.jpg",
			webUrl: "https://edetayyapi.com/",
			desc: "The Edetay Yapi Landing Page is a freelance project showcasing an construction company's services and contact information to attract potential clients.",
			category: "Frontend Development",
		},
		{
			title: "AI Chatbot for Seamless Conversations",
			image: "/images/chatbot_project.jpg",
			webUrl: "https://keremunce.github.io/nextjs-AIChatbot/",
			desc: "A simple AI chatbot project developed to demonstrate integration with conversational AI, offering a clean design and functional chat interface for interactive user engagement.",
			category: "Frontend Development",
		},
		{
			title: "Calculator App",
			image: "/images/calculator_project.jpg",
			webUrl: "https://keremunce.github.io/calculator/",
			desc: "A sleek and efficient calculator app designed by Kerem Unce. Perform basic arithmetic operations with ease on a user-friendly interface.",
			category: "Frontend Development",
		},
		{
			title: "Task Manager",
			image: "/images/taskmanager_project.jpg",
			webUrl: "https://keremunce.github.io/calculator/",
			desc: "An organized and efficient task management tool designed to help users keep track of their tasks and deadlines. The interface is intuitive, making task creation and management straightforward.",
			category: "Frontend Development",
		},
	];

	return (
		<>
			<section className="PortfolioTab-container">
				<div className="subtitle">
					<p>
						<i className="ti-user text-orange-600"></i>My Works
					</p>
				</div>
				<div className="title">
					<h2>Portfolio</h2>
				</div>

				{/* UI & UX Design Section */}
				<div className="category-section mt-12">
					<div className="category-header mb-8 inline-block">
						<h3 className="text-2xl font-bold mb-2">UI & UX Design</h3>
						<div className="w-12 h-1 rounded bg-orange-600"></div>
					</div>
					<div className="inner-container">
						{projects
							.filter((project) => project.category === "UI & UX Design")
							.map((project, index) => (
								<div key={index} className="projectBox">
									<div className="img-container">
										<img src={project.image} alt="" />
									</div>
									<div className="content-container">
										<h3 className="title">{project.title}</h3>
										<p className="description">{project.desc}</p>
									</div>
									<div className="button-container">
										{project.webUrl && project.webUrl.trim() !== "" && (
											<a href={project.webUrl} rel="noreferrer" target="_blank">
												Website <i className="ti ti-arrow-top-right"></i>
											</a>
										)}
										{project.appUrl && project.appUrl.trim() !== "" && (
											<a href={project.appUrl} rel="noreferrer" target="_blank">
												<Apple />
												App
											</a>
										)}
									</div>
								</div>
							))}
					</div>
				</div>

				{/* Frontend Development Section */}
				<div className="category-section mt-12">
					<div className="category-header mb-8 inline-block">
						<h3 className="text-2xl font-bold mb-2">Frontend Development</h3>
						<div className="w-12 h-1 rounded bg-orange-600"></div>
					</div>
					<div className="inner-container">
						{projects
							.filter((project) => project.category === "Frontend Development")
							.map((project, index) => (
								<div key={index} className="projectBox">
									<div className="img-container">
										<img src={project.image} alt="" />
									</div>
									<div className="content-container">
										<h3 className="title">{project.title}</h3>
										<p className="description">{project.desc}</p>
									</div>
									<div className="button-container">
										{project.webUrl && project.webUrl.trim() !== "" && (
											<a href={project.webUrl} rel="noreferrer" target="_blank">
												Website <i className="ti ti-arrow-top-right"></i>
											</a>
										)}
										{project.appUrl && project.appUrl.trim() !== "" && (
											<a href={project.appUrl} rel="noreferrer" target="_blank">
												<Apple />
												App
											</a>
										)}
									</div>
								</div>
							))}
					</div>
				</div>
			</section>
		</>
	);
}
